// Moved to @hyperframes/parsers. Re-exported here for back-compat.
export {
  rewriteAssetPath,
  rewriteAssetPaths,
  rewriteInlineStyleAssetUrls,
  rewriteCssAssetUrls,
  type AssetExists,
} from "@hyperframes/parsers/asset-paths";
